<p-dialog
  #staticDialog
  [header]="'ABOUT.TITLE' | translate"
  [modal]="true"
  [(visible)]="aboutVisible"
  (visibleChange)="aboutVisibleChange.emit($event)"
  [style]="{ width: '100vw', height: '100vh', maxHeight: '100vh' }"
  [breakpoints]="{ '74.9375rem': '75vw', '35.9375rem': '90vw' }"
>
  <div class="max-w-none lg:max-w-[50%] mx-auto">
    <h2 class="sr-only">{{ 'ABOUT.TITLE' | translate }}</h2>
    <p class="my-7">
      {{ 'ABOUT.INTRO' | translate }}
    </p>
    <p class="my-7 font-bold">{{ 'ABOUT.SECTIONS.INTELLIGENT.TITLE' | translate }}</p>
    <p>
      {{ 'ABOUT.SECTIONS.INTELLIGENT.BODY' | translate }}
    </p>
    <p class="my-7 font-bold">{{ 'ABOUT.SECTIONS.INTERFACE.TITLE' | translate }}</p>
    <p>
      {{ 'ABOUT.SECTIONS.INTERFACE.BODY' | translate }}
    </p>
    <p class="my-7 font-bold">{{ 'ABOUT.SECTIONS.FUNCTIONALITY.TITLE' | translate }}</p>
    <p>
      {{ 'ABOUT.SECTIONS.FUNCTIONALITY.BODY' | translate }}
    </p>
    <p class="my-7 font-bold">{{ 'ABOUT.SECTIONS.AVAILABILITY.TITLE' | translate }}</p>
    <p>
      {{ 'ABOUT.SECTIONS.AVAILABILITY.BODY' | translate }}
    </p>
    <p class="my-7 font-bold">{{ 'ABOUT.SECTIONS.SECURITY.TITLE' | translate }}</p>
    <p>
      {{ 'ABOUT.SECTIONS.SECURITY.BODY' | translate }}
    </p>
    <p class="my-7 font-bold">{{ 'ABOUT.SECTIONS.IMPROVEMENT.TITLE' | translate }}</p>
    <p>
      {{ 'ABOUT.SECTIONS.IMPROVEMENT.BODY' | translate }}
    </p>
    <p class="my-7">
      {{ 'ABOUT.CLOSING' | translate }}
    </p>
  </div>
</p-dialog>
